import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Distributor } from '../../../models/distributor.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef,MatListOption } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { DistributorService } from '../../../services/distributor.service';

@Component({
  selector: 'app-distributor-region-form',
  templateUrl: './distributor-region-form.component.html',
  styleUrls: ['./distributor-region-form.component.scss']
})
export class DistributorRegionFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  
  rmList : any = [];
  dialogHeader : string = "";
  rmMainList : any = [];
  filteredList: any = [];
  fhMapping : any = [];
  distributorId : Number = 0;
  actionType : Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  user = new Distributor();  
  toggleValue: Boolean = false;
  loadingIndicator = false;
  reorderable = true;

  translations: any;
  
  constructor( @Inject(MAT_DIALOG_DATA)
  public data: { Id : 0, type: 0 },
  public dialog: MatDialog,
  private formBuilder: FormBuilder,
  public appService: AppService,
  private distService: DistributorService,
  public dialogRef: MatDialogRef<DistributorRegionFormComponent>){
    this.setPageTranslations();
    this.distributorId = this.data.Id;
    this.setHeader();
  }
  setHeader(){
    this.dialogHeader = this.actionType == 21 ? this.translations["headerRole"] : this.actionType == 22 ? this.translations["headerDistributor"] :  this.translations["headerShipper"];
  }
  ngOnInit() {
    this.select();
  }
  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  } 
  select(): void{
    this.distService.selectRegionMappings(this.distributorId).subscribe(
      res => this.selectSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  selectSuccess(res): void{
    if (res.Status) {
      if(res.Data != 'null' && JSON.parse(res.Data).length > 0){
        this.rmList = JSON.parse(res.Data);
        this.rmMainList = this.rmList;
        }
      else{
        this.apiFaillure("No data");
        }
    } else {
      this.apiFaillure(res.Message);
    }
  }
  apiFaillure(error): void {
    this.appService.showDialogue("Error", error);
  }
  close(){
    this.dialogRef.close();
  }
  save(): void{
    this.distService.saveRegionMappings(JSON.stringify(this.rmMainList)).subscribe(
      res => this.userMappingSuccess(res),
      error => this.apiFaillure(error)
    ); 
  }
  userMappingSuccess(res): void{
    if (res.Status) {
      this.appService.showDialogue("Success",this.translations[res.Message])
      .afterClosed().subscribe(result => {
          if (result) {
            this.close();
          }          
      });    
    } else {
      this.apiFaillure(this.translations[res.Message]);
    }
  }
  selectDeselectAll(regionList: any){
    if(!this.toggleValue){
        regionList.selectAll();
        this.toggleValue = true;
    }
    else{
        regionList.deselectAll();
        this.toggleValue = false;
    }
  }
  onSearchChange(searchValue : string) {  
    this.rmList = this.rmMainList.filter(rm => rm.Name.startsWith(searchValue));
      if(searchValue == ''){
          this.toggleValue = false;
      }
  }
    selectChange(value,name){
        var selectedvalue;
        this.rmMainList.filter(function(fltrResult){
            if(fltrResult.Name == name){    
                fltrResult.Status = value.selected;
            }
        });
    }
}





// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/distributor-region-form/distributor-region-form.component.ts